<template>
  <div class="mfaSetting">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MfaSetting',
};
</script>

<style lang="scss">
.mfaSetting {
  height: 100%;
}
</style>
